/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Tss_One_LinerInputs */

const en_exp_tss_one_liner = /** @type {(inputs: Exp_Tss_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measures how hard a workout was relative to your personal threshold.`)
};

const de_exp_tss_one_liner = /** @type {(inputs: Exp_Tss_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misst, wie hart ein Training relativ zu deiner Schwelle war.`)
};

/**
* | output |
* | --- |
* | "Measures how hard a workout was relative to your personal threshold." |
*
* @param {Exp_Tss_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_tss_one_liner = /** @type {((inputs?: Exp_Tss_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Tss_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_tss_one_liner(inputs)
	return de_exp_tss_one_liner(inputs)
});